import { z } from 'zod';

export const markRafflePrizeCollectedResDto = z.object({
  collectedAt: z.coerce.date(),
});

export type MarkRafflePrizeCollectedResDto = z.infer<
  typeof markRafflePrizeCollectedResDto
>;
